// extracted by mini-css-extract-plugin
export default {"container":"Row_container__HBK3b","content":"Row_content__U6nFQ","img":"Row_img__M6m6A","name":"Row_name__1F9xs","increase":"Row_increase__5gejl","decrease":"Row_decrease__+gPpf"};